import * as Yup from 'yup';

export const AddRecommendationFormSchema = Yup.object().shape({
  q1: Yup.object()
    .nullable()
    .required('This field is required'),

  q2: Yup.object()
    .nullable()
    .required('This field is required'),

  q3: Yup.object()
    .nullable()
    .required('This field is required'),

  q4: Yup.object()
    .nullable()
    .required('This field is required'),

  q5: Yup.array()
    .nullable()
    .test(
      'min-q5',
      'Please select 3 answers for question',
      value => value && value.length === 3
    ),

  recommendation: Yup.string()
    .nullable()
    .max(5000, 'You have exceeded the maximum number of 5000 characters')
    .required('Please input your recommendation'),

  token: Yup.string()
    .nullable()
    .required('This field is required'),
});
